/**
 * Manager-Code aus lokalen Quellen (ohne Supabase).
 */

import { kvGet } from '../infrastructure/storage/kvAccess';
import { normalizeBusinessStorageId } from './sharedCore';
import { shouldAllowSupabaseNetwork } from './supabaseReachability';
import {
  collectManagerCodesForBusiness,
  isManagerCodeValid,
  isManagerCodeValidAsync,
  mergeOfflineBusinessRecords,
  parseOfflineBusinessList,
  extractBusinessesFromOfflineUsers,
  readAuthListFromNativeLocalStorage,
  resolvePreferredManagerCode
} from './authCredentialRead';

function idsMatch(a, b) {
  if (a == null || b == null) return false;
  return normalizeBusinessStorageId(a) === normalizeBusinessStorageId(b);
}

function readOfflineBusinesses() {
  try {
    return mergeOfflineBusinessRecords(
      readAuthListFromNativeLocalStorage('offline_businesses'),
      extractBusinessesFromOfflineUsers([
        ...readAuthListFromNativeLocalStorage('offline_users'),
        parseOfflineBusinessList(kvGet('offline_users'))
      ]),
      parseOfflineBusinessList(kvGet('offline_businesses'))
    );
  } catch {
    return [];
  }
}

export { collectManagerCodesForBusiness, isManagerCodeValid, isManagerCodeValidAsync };

/**
 * @param {string} [businessId]
 * @returns {string|null}
 */
export function resolveLocalManagerCode(businessId = null) {
  return resolvePreferredManagerCode(businessId);
}

/** Business-Metadaten aus offline_businesses nachziehen wenn currentBusiness nur { id } hat. */
export function enrichCurrentBusinessFromOfflineStore(businessId) {
  const bid = normalizeBusinessStorageId(businessId);
  if (!bid) return null;

  const offline = readOfflineBusinesses().find((b) => idsMatch(b.id, bid));
  if (!offline) return null;

  const existing = kvGet('currentBusiness');
  const prev =
    existing && typeof existing === 'object' && !Array.isArray(existing) ? existing : { id: bid };

  return {
    ...offline,
    ...prev,
    id: prev.id || offline.id,
    manager_code: prev.manager_code || offline.manager_code
  };
}

/**
 * Supabase nur wenn explizit Cloud-Account (nicht offline-only).
 * @param {object|null} business
 */
export function shouldSyncManagerCodeWithSupabase(business = null) {
  if (!shouldAllowSupabaseNetwork()) return false;
  if (!process.env.REACT_APP_SUPABASE_URL) return false;

  const user = kvGet('currentUser');
  if (user && typeof user === 'object' && user.offline === true) return false;
  if (business?.offline === true) return false;

  if (user?.supabaseAuth !== true) {
    const offline = readOfflineBusinesses();
    if (offline.some((b) => idsMatch(b.id, business?.id))) {
      return false;
    }
  }

  return true;
}
